<template>
    <amplify-authenticator>
        <v-card class="overflow-hidden" >
            <v-app-bar
                color="primary"
                dark
            >
                <!-- 'prominent' en el v-app-bar lo hace grande -->
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-app-bar-nav-icon
                            v-bind="attrs"
                            v-on="on"
                        ></v-app-bar-nav-icon>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in menuItems"
                            :key="index"
                            :to="item.to"
                        >
                            <v-list-item-title> {{ item.title }} </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <amplify-sign-out></amplify-sign-out>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <!-- <div class="d-flex align-center"> -->
                <v-img
                    alt="Logotipo Monitor de Temperaturas"
                    class="shrink mr-2"
                    contain
                    :src="toolbarLogo"
                    transition="scale-transition"
                    height="66"
                />
                <!-- </div> -->

                <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn
                    icon
                    to="/grafica"
                    v-if="showMainItems"
                >
                    <v-icon>mdi-chart-line</v-icon>
                </v-btn>

                <v-btn
                    icon
                    to="/tabla"
                    v-if="showMainItems"
                >
                    <v-icon>mdi-table</v-icon>
                </v-btn>

                <!-- Everybody can see the status page -->
                <v-btn
                    icon
                    to="/estatus"
                >
                    <v-icon>mdi-clipboard-check-multiple-outline</v-icon>
                </v-btn>

                <v-btn
                    icon
                    to="/salidas"
                    v-if="showCheckoutItem">
                    <v-icon>mdi-truck-delivery-outline</v-icon>
                </v-btn>

                <v-btn
                    icon
                    to="/promedios">
                    <v-icon>mdi-temperature-celsius</v-icon>
                </v-btn>

                <v-btn
                    icon
                    to="/usuarios"
                    v-if="showSuperUserItems">
                    <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>

                <v-btn
                    icon
                    to="/admin"
                    v-if="showSuperUserItems">
                    <v-icon>mdi-cog</v-icon>
                </v-btn>

                <template v-slot:extension>

                    <!-- T&D Menu -------------------------------------------------------------- -->
                    <template v-if="showMenu">
                        <v-slide-group
                            show-arrows>
                            <v-slide-item
                                v-for="(topMenuItem, topIndex) in menuStructure"
                                :key="topIndex"
                            >
                                <v-menu
                                    offset-y
                                >
                                    <template v-slot:activator="{ on : menu, attrs }">
                                        <v-btn
                                            text
                                            color="white"
                                            v-bind="attrs"
                                            v-on="{ ...menu }"
                                        >
                                            {{ topMenuItem.location }}
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            v-for="( account, index ) in topMenuItem.accounts"
                                            :key="index"
                                            @click="showAccount( account)"
                                        >
                                            <v-list-item-title>{{ account.description }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-slide-item>
                        </v-slide-group>
                    </template>
                    <!-- ----------------------------------------------------------------------- -->

                    <!-- T&D Tabs -------------------------------------------------------------- -->
                    <template v-if="showTabs" >
                        <v-btn text disabled>
                            {{ globalState.account.location }}
                        </v-btn>

                        <v-tabs
                            align-with-title
                            v-if="showTabs"
                        >
                            <v-tab
                                v-for="(account, index) in userAccounts"
                                :key="index"
                                @click="showAccount( account )"
                            >
                                {{ account.description }}
                            </v-tab>
                        </v-tabs>
                    </template>
                    <!-- ----------------------------------------------------------------------- -->
                </template>
            </v-app-bar>

            <v-container>
                <v-content>
                    <router-view></router-view>
                </v-content>
            </v-container>
        </v-card>
    </amplify-authenticator>
</template>
<script>

import { Auth, Hub, Logger } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import { text, currentLanguage } from '@/language';
import { dayjs, peek } from '@/tools';
peek;

import { mapActions, mapGetters } from 'vuex';

const logger = new Logger( 'SignedInView' );

const TIMEOUT_SECONDS = 4 * 60 * 60;
const LOGOUT_CHECK_SECONDS = 60;

const toolbarLogo =
    currentLanguage() === 'es' ? require( '../assets/logo-monitor-toolbar.png' )
                               : require( '../assets/logo-monitor-toolbar.png' ); 

const makeMenuStructure = ( structure, account ) => {
    const location = account.location;
    if ( ! structure[ location ] )
        structure[ location ] = [];

    structure[ location ].push( account );

    return structure;
};

export default {
    name: 'SignedInView',

    created() {
        this.globalState = this.$root.$data.globalState;

        this.apiListTndAccounts();
        this.apiSubscribeToTndAccountEvents();
        this.fetchCurrentAuthenticatedUser();

        if ( this.userAccounts.length > 0 )
            this.showAccount( this.userAccounts[0] );

        Hub.listen( 'monitor', data => {
            if ( ['ev:userRole'].includes( data.payload.event ) )
                this.computeMenuItems();

            if ( ['ev:setAccount'].includes( data.payload.event ) )
                this.computeLocationMenu();
        } );
        this.computeMenuItems();
        this.computeLocationMenu();
    },

    mounted() {
        this.startLogoutInterval();
        this.addLogoutEventListeners();

        
    },

    destroyed() {
        this.clearLogoutInterval();
        this.removeLogoutEventListeners();
    },

    watch : {
        $route() { // ( to, from )
            this.computeLocationMenu();
        },
    },

    components: {
    },

    computed: {
        ...mapGetters( {
            currentUser : 'getCurrentUser',
            userAccounts : 'getUserTndAccounts',
        } ),

        menuStructure() {
            return Object.entries( this.userAccounts.reduce( makeMenuStructure, {} ) )
                         .map( ( [location, accounts] ) => ({ location, accounts} ) );
        }, // menuStructure
    },

    data: () => ({
        globalState : {},

        // everybody can see the status page
        showMainItems : false,      // Regular user features: table, graph
        showSuperUserItems : false, // Super user features: T&D account admnistration
        showCheckoutItem : false,   // Checkout feature.

        toolbarLogo,
        toolbarTitle : text( 'signedInViewToolbarTitle' ),
        menuItems : [], // these are the buttons on the top right
        logoutInterval : null,
        lastActiveTimeSeconds : dayjs().unix(),
        logoutEvents : ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],

        // Tabs
        showTabs : false,

        // Menu
        showMenu : false,
    }),

    methods : {

        ...mapActions( [
            'fetchCurrentAuthenticatedUser',
            'apiListTndAccounts',
            'apiSubscribeToTndAccountEvents',
        ] ),

        showAccount( account ) {
            this.globalState.setAccount( account );
        },

        computeMenuItems() {
            const userRole = this.globalState.userRole;

            this.showSuperUserItems = userRole.isSuperUser;
            this.showMainItems      = ! userRole.isCheckoutUser || userRole.isSuperUser;
            this.showCheckoutItem   = userRole.isCheckoutUser   || userRole.isSuperUser;

            let menuItems = [];

            if ( this.showMainItems ) {
                const mainItems = [
                    { title : text( 'graphViewName' ), to : text( 'graphViewPath' ) },
                    { title : text( 'tableViewName' ), to : text( 'tableViewPath' ) },
                    { title : text( 'statusViewName' ), to : text( 'statusViewPath' ) },
                    { title : text( 'averageTemperatureViewName' ), to : text( 'averageTemperatureViewPath' ) },
                ];

                menuItems = menuItems.concat( mainItems );
            }

            if ( this.showCheckoutItem ) {
                menuItems.push( { title : text( 'checkoutViewName' ), to : text( 'checkoutViewPath' ) } );
            }

            if ( this.showSuperUserItems ) {
                menuItems.push( { title : text( 'usersViewName' ), to : text( 'usersViewPath' ) } );
                menuItems.push( { title : text( 'adminViewName' ), to : text( 'adminViewPath' ) } );
            }

            this.menuItems = menuItems;
        },

        computeLocationMenu() { 
            // const count = this.menuStructure.length;
            // We were using tabs when showing only one account, but we disabled them
            // as there were glitches (no left/right tab scrolling buttons)
            this.showTabs = false;
            this.showMenu = this.$route.path !== text( 'checkoutViewPath' );
        },

        addLogoutEventListeners() {
            this.logoutEvents.forEach( event =>
                window.addEventListener( event, this.resetLogoutTimer ) );

            window.onunload = async event => {
                console.log( 'beforeUnload' );
                event.preventDefault();
                try {
                    await this.logout( true );
                }
                catch ( error )
                {
                    logger.error( 'Error loging the user out on unload', error );
                }
                return true;
            };
        },

        removeLogoutEventListeners() {
            this.logoutEvents.forEach( event =>
                window.removeEventListener( event, this.resetLogoutTimer ) );
        },

        startLogoutInterval() {
            this.clearLogoutInterval();
            this.logoutInterval = setInterval( this.logout, LOGOUT_CHECK_SECONDS * 1000 );
        },

        clearLogoutInterval() {
            if ( this.logoutInterval == null )
                return;

            clearInterval( this.logoutInterval );
            this.logoutInterval = null;
        },

        resetLogoutTimer() {
            this.lastActiveTimeSeconds = dayjs().unix();
        },

        logout( forceLogout ) {
            const idleSeconds = dayjs().unix() - this.lastActiveTimeSeconds;

            if ( idleSeconds < TIMEOUT_SECONDS && ! forceLogout ) {
                return Promise.resolve( true );
            }

            if ( idleSeconds < TIMEOUT_SECONDS ) {
                console.log( 'Forcing a logout' );
            }
            else {
                console.log( 'User has been idle for too long, loging them out' );
            }

            return Auth.signOut()
                .then( () => logger.info( 'You have been automatically logged out' ) )
                .catch( error => logger.error( 'Error signing out', error ) );
        }, // logout
    }, // methods
};
</script>
